import React, { ReactNode } from 'react';
import { Currency, ISelectOption } from 'ui-toolkit';
import { DisplayTransactionCategory, eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { ePartyPurpose } from '../../ui-toolkit/enums/ePartyPurpose';
import { ITransaction } from '../../ui-toolkit/orders/interfaces/ITransaction';
import { FullName, IParty, isBuyerBorrower } from '../../ui-toolkit/orders/interfaces/IParty';
import { upperFirst, isNil } from 'lodash';
import { notEmpty } from '../../ui-toolkit/utilities/notEmpty';

const labelValueOrNull = (condition: any, label: string, value: ReactNode): ISelectOption<ReactNode> | null =>
  !!condition ? { label, value } : null;

export const generatePageHeaderDataPoints = (
  {
    transaction_category,
    file_number,
    purchase_price,
    estimated_property_value,
    loan_amount,
    loan_number,
  }: ITransaction,
  parties: IParty[],
  creator?: string,
  countyName?: string | null
): ReactNode[] | ISelectOption<ReactNode>[][] => {
  const partiesToShow = determinePartiesToShow(parties);
  const sellersToShow = parties.filter((party) => party.purpose === ePartyPurpose.seller);
  const names = partiesToShow.map(FullName).join(', ');
  const sellerNames = sellersToShow.map(FullName).join(', ');

  const firstRow = [
    { label: 'Transaction Type:', value: DisplayTransactionCategory[transaction_category] },
    labelValueOrNull(purchase_price, 'Purchase Price:', <Currency value={purchase_price} emptyContent={'$0.00'} />),
    labelValueOrNull(
      !isNil(estimated_property_value) && transaction_category === eTransactionCategory.Refinance,
      'Estimated Property Value:',
      <Currency value={estimated_property_value} emptyContent={'$0.00'} />
    ),
    labelValueOrNull(loan_amount, 'Loan Amount:', <Currency value={loan_amount} />),
    labelValueOrNull(countyName, 'County:', upperFirst(countyName ?? '')),
  ].filter(notEmpty);

  const secondRow = [
    { label: 'Order Number:', value: file_number },
    labelValueOrNull(loan_number, 'Loan ID:', loan_number),
    { label: `${transaction_category === eTransactionCategory.Purchase ? 'Buyer' : 'Borrower'}:`, value: names },
    labelValueOrNull(creator, 'Creator:', creator),
    labelValueOrNull(sellerNames, `${upperFirst(ePartyPurpose.seller)}:`, sellerNames),
  ].filter(notEmpty);

  return [firstRow, secondRow];
};

export const determinePartiesToShow = (parties: IParty[]): IParty[] => parties.filter(isBuyerBorrower);
